import { View } from 'react-native'
import { Link } from 'expo-router'
import Page from '@shell/Page'
import Typography from '@ui/typography'
import Status from '@ui/elements/Status'

export default function DevUIPage() {
  return (
    <Page stage="dev">
      <View className="flex gap-8 p-16">
        <Link href="/dev/typography">
          <Typography variant="LG">Typography</Typography>
        </Link>
        <Link href="/dev/buttons">
          <Typography variant="LG">Buttons</Typography>
        </Link>
        <Link href="/dev/forms">
          <Typography variant="LG">Forms</Typography>
        </Link>
        <Link href="/dev/slider">
          <Typography variant="LG">Slider</Typography>
        </Link>
        <Link href="/dev/cofidis-monthly-application">
          <Typography variant="LG">Cofidis Monthly Application</Typography>
        </Link>
        <Link href="/dev/checklist">
          <Typography variant="LG">Checklist</Typography>
        </Link>
        <Link href="/dev/tiles">
          <Typography variant="LG">Tiles</Typography>
        </Link>
        <Link href="/dev/steps">
          <Typography variant="LG">Steps</Typography>
        </Link>
        <Link href="/dev/options">
          <Typography variant="LG">Options</Typography>
        </Link>
        <Link href="/dev/picker">
          <Typography variant="LG">Picker</Typography>
        </Link>
        <Link href="/dev/orders">
          <Typography variant="LG">Orders</Typography>
        </Link>
        <Link href="/dev/discounts">
          <Typography variant="LG">Discounts</Typography>
        </Link>
        <Link href="/dev/segmented">
          <Typography variant="LG">Segmented</Typography>
        </Link>
        <Link href="/dev/frame">
          <Typography variant="LG">Frame</Typography>
        </Link>
        <Link href="/dev/payment-status">
          <Typography variant="LG">Payment Status</Typography>
        </Link>
        <Link href="/dev/checkbox-group">
          <Typography variant="LG">Checkbox Group</Typography>
        </Link>
        <Link href="/dev/code">
          <Typography variant="LG">Code Input</Typography>
        </Link>
        <Link href="/dev/topbar">
          <Typography variant="LG">Topbar</Typography>
        </Link>
        <Link href="/dev/toasts">
          <Typography variant="LG">Toasts</Typography>
        </Link>
        <Link href="/dev/notifications">
          <Typography variant="LG">Notifications Test</Typography>
        </Link>
        <Link href="/dev/input-controlled">
          <Typography variant="LG">Input Controlled</Typography>
        </Link>
        <Link href="/dev/packages-points">
          <Typography variant="LG">Packages Points</Typography>
        </Link>
        <Link href="/dev/packages-attributes">
          <Typography variant="LG">Packages Attributes</Typography>
        </Link>
        <Link href="/dev/image-navigation">
          <Typography variant="LG">Image Navigation</Typography>
        </Link>
        <Link href="/dev/modals/modals">
          <Typography variant="LG">Modals</Typography>
        </Link>
        <Link href="/dev/forms-modals">
          <Typography variant="LG">Forms Modals</Typography>
        </Link>
        <Link href="/dev/account-details">
          <Typography variant="LG">Account Details Tiles</Typography>
        </Link>
        <Link href="/staff/create-customer">
          <Typography variant="LG">Create Customer (new screen)</Typography>
        </Link>
        <Link href="/dev/measurements">
          <Typography variant="LG">Measurements UI</Typography>
        </Link>
      </View>
    </Page>
  )
}
